<template>
  <v-container
    px-12
    :class="$route.name === 'HistoryEvent' && $style.eventContainer"
    :style="{
      overflowY: 'auto',
      maxHeight: $route.name === 'HistoryEvent' ? '100%' : `${tableHeight}px`
    }"
  >
    <v-row>
      <v-col>
        <span class="text-overline pb-2">Konsekvens</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          no-resize
          outlined
          :disabled="isHistoryEvent"
          label="Konsekvens"
          :placeholder="isHistoryEvent ? '' : 'Skriv Konsekvens...'"
          @input="v => checkEmpty('consequence', v)"
          v-model="consequence"
          :append-icon="isDiff('consequence') ? 'mdi-alert-octagram' : ''"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <span class="text-overline pb-2">Prognos</span>
      </v-col>
    </v-row>

    <TrafficMessageForecastField
      :disabled="isHistoryEvent"
      :check-empty="checkEmpty"
      :is-diff="isDiff('forecast_comment')"
    />

    <v-row>
      <v-col>
        <span class="text-overline pb-2">Ersättningstrafik</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Kommentar"
          outlined
          :placeholder="isHistoryEvent ? '' : 'Skriv kommentar...'"
          v-model="replacement_comment"
          @input="v => checkEmpty('replacement_comment', v)"
          :append-icon="
            isDiff('replacement_comment') ? 'mdi-alert-octagram' : ''
          "
          :disabled="isHistoryEvent"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="text-overline pb-2">Gulväst</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Kommentar"
          outlined
          :placeholder="isHistoryEvent ? '' : 'Skriv kommentar...'"
          v-model="yellow_vest_comment"
          @input="v => checkEmpty('yellow_vest_comment', v)"
          :append-icon="
            isDiff('yellow_vest_comment') ? 'mdi-alert-octagram' : ''
          "
          :disabled="isHistoryEvent"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import inputTableHeight from '@/mixins/inputTableHeight'
import { sync, get } from 'vuex-pathify'
import TrafficMessageForecastField from './TrafficMessageForecastField'

export default {
  name: 'TrafficMessageForm',

  components: {
    TrafficMessageForecastField
  },

  mixins: [inputTableHeight(334)],

  computed: {
    model: sync('trafficMessage/model'),
    replacement_comment: sync('trafficMessage/model@replacement_comment'),
    yellow_vest_comment: sync('trafficMessage/model@yellow_vest_comment'),
    consequence: sync('trafficMessage/model@consequence'),
    selectedEvent: get('event/selectedEvent'),
    isHistoryEvent: get('history/isHistoryEvent')
  },

  methods: {
    isDiff(prop) {
      if (this.isHistoryEvent) {
        return false
      }
      const currentTrafficMessage =
        this.selectedEvent?.last_traffic_message || null
      if (!currentTrafficMessage) return false
      return currentTrafficMessage[prop] !== this.model[prop]
    },

    checkEmpty(prop, value) {
      if (!value || !value.length) {
        this.model[prop] = null
      }
    }
  }
}
</script>

<style lang="scss" module>
.eventContainer {
  height: calc(100vh - 176px);
}
</style>
